"use strict";

(function () {
  "use strict";

  angular.module("course.selectionElearnings", ["ui.router", "common"]);
})();